import { useTranslation } from 'react-i18next';
import { SttFormSelect } from '../forms/SttFormSelect';

type Props = {
    name: string;
    defVal: string;
    onChange: (event: { name: string | undefined; value: unknown }) => void;
    [key: string]: unknown;
};

export function SttSelectDeviceStatus({
    name,
    defVal,
    onChange,
    ...rest
}: Props): React.ReactElement {
    const { t } = useTranslation();

    return (
        <SttFormSelect
            caption={t('labels.status')}
            name={name}
            defVal={defVal}
            {...rest}
            options={[
                {
                    caption: t('deviceStatus.active'),
                    value: 'ACTIVE',
                },
                {
                    caption: t('deviceStatus.inactive'),
                    value: 'INACTIVE',
                },
                {
                    caption: t('deviceStatus.open'),
                    value: 'OPEN',
                },
            ]}
            onChange={onChange as any}
            mandatory
        />
    );
}
